import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import {
	NbFormFieldModule,
	NbButtonModule,
	NbIconModule,
	NbInputModule,
	NbTooltipModule,
	NbToastrService
} from '@nebular/theme';

export interface DataHubFieldProps {
	dateFormat?: string;
}

@Component({
	selector: 'formly-nebular-input',
	template: `
		<nb-form-field>
			<input nbInput fullWidth type="text" [formControl]="formControl" [attr.list]="operatorsListId" />
			@if (operators().length) {
				<datalist [id]="operatorsListId">
					@for (operator of operators(); track operator.value) {
						<option [value]="operator.value">{{ operator.value }}</option>
					}
				</datalist>
			}
			@if (props.dateFormat) {
				<button
					nbButton
					nbSuffix
					ghost
					size="small"
					status="primary"
					type="button"
					[nbTooltip]="'Apply date format: ' + props.dateFormat"
					(click)="applyDateFormat()"
				>
					<nb-icon icon="calendar"></nb-icon>
				</button>
			}
		</nb-form-field>
	`,
	imports: [ReactiveFormsModule, NbFormFieldModule, NbButtonModule, NbIconModule, NbInputModule, NbTooltipModule]
})
export class FormlyNebularInputTypeComponent extends FieldType<FieldTypeConfig<DataHubFieldProps>> {
	protected operatorsListId = `operators-${Math.random().toString(36).slice(2)}`;

	constructor(private toastrService: NbToastrService) {
		super();
	}

	protected operators() {
		return this.field.options?.formState?.operators ?? [];
	}

	protected applyDateFormat() {
		const currentValue = this.formControl.value || '';
		const dateFormat = this.props.dateFormat;
		if (!currentValue || !dateFormat) {
			this.toastrService.warning('No value to format or missing date format', 'Error');
			return;
		}

		const formattedValue = currentValue.replace(/}$/, ` | ${dateFormat}}`);
		if (formattedValue === currentValue) {
			this.toastrService.warning('Could not apply format - value must end with }', 'Format Failed');
			return;
		}

		this.formControl.setValue(formattedValue);
	}
}
